import * as qs from "app/lib/helperjs";
import {CONFIG} from "config/config";

const CHAT_SCRIPT_ID = 'TAWK_CHAT_SCRIPT_ID';
const CHAT_MAXIMIZATOR = '[data-target="chat"]';

const chatInitialization = () => {
    const chatConfig = CONFIG.TAWK;
    const currentLang = document.documentElement.lang;

    if (!chatConfig.IS_ENABLED || qs.querySelector(`#${CHAT_SCRIPT_ID}`)) {
        return;
    }

    const getChatChannel = () => {
        switch (currentLang) {
        case 'pl-PL':
            return chatConfig.POLISH_CHANNEL;
        case 'ru-RU':
            return chatConfig.RUSSIAN_CHANNEL;
        case 'uk-UA':
        case 'ua-UA':
            return chatConfig.UKRAINIAN_CHANNEL;
        default:
            return chatConfig.ENGLISH_CHANNEL;
        }
    };

    const channel = getChatChannel();
    const script = qs.createElement('script', {
        id: CHAT_SCRIPT_ID,
        async: true,
        src: `https://embed.tawk.to/${channel}/default`,
        charset: 'UTF-8',
        crossorigin: '*'
    });

    qs.appendElement(script, window.document.head);
};

const maximizeChat = () => {
    const chatConfig = CONFIG.TAWK;
    const maximizators = qs.querySelectorAll(CHAT_MAXIMIZATOR);

    if (!chatConfig.IS_ENABLED || maximizators.length === 0) {
        return;
    }

    qs.addEventListener(maximizators, 'click', () => {
        if (!window.Tawk_API) {
            return;
        }

        window.Tawk_API.maximize();
    });
};

export const tawkChat = () => {
    chatInitialization();
    maximizeChat();
};
